// extracted by mini-css-extract-plugin
export default {"imgContainer":"ImageGrid_imgContainer__1q6i+"};